import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const PACKAGE_URLS = {
  1: 'https://widget.zenbooker.com/book/1763871181776x633987278981962200?embed=true&preselected-service=1771580569635x120676874812220900',
  2: 'https://widget.zenbooker.com/book/1763871181776x633987278981962200?embed=true&preselected-service=1771583363232x833101827083369600',
  3: 'https://widget.zenbooker.com/book/1763871181776x633987278981962200?embed=true&preselected-service=1771614993868x627626873665103600'
};

export const BookingModal = ({ isOpen, onClose, packageLevel = 1, customUrl = null }) => {
  const [iframeKey, setIframeKey] = useState(0);
  const widgetUrl = customUrl || PACKAGE_URLS[packageLevel] || PACKAGE_URLS[1];

  // Reset iframe when opening modal
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setIframeKey(prev => prev + 1);
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, packageLevel]);

  const handleClose = () => {
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4"
          data-testid="booking-modal"
        >
          {/* Backdrop */}
          <div 
            className="absolute inset-0 bg-black/85"
            onClick={handleClose}
          />
          
          {/* Modal */}
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            className="relative w-full max-w-4xl max-h-[90vh] bg-[#0a0a0a] border border-white/10 rounded-lg overflow-hidden"
          >
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-white/10">
              <h3 className="font-heading text-xl font-semibold uppercase tracking-wider text-white">
                Book Your Appointment
              </h3>
              <button
                onClick={handleClose}
                className="p-2 hover:bg-white/10 rounded-full transition-colors"
                data-testid="close-booking-modal"
                aria-label="Close booking modal"
              >
                <X className="w-6 h-6 text-white" />
              </button>
            </div>
            
            {/* Iframe Widget Container */}
            <div className="p-4 overflow-auto" style={{ maxHeight: 'calc(90vh - 80px)' }}>
              <div 
                className="w-full rounded-lg overflow-hidden"
                style={{ 
                  boxShadow: '0px 1px 8px rgba(0,0,0,0.08)', 
                  border: '1px solid rgb(50, 50, 50)',
                  backgroundColor: '#fff'
                }}
              >
                <iframe
                  key={iframeKey}
                  src={widgetUrl}
                  title="Book Appointment"
                  style={{ 
                    width: '100%',
                    height: '600px',
                    border: 'none',
                    display: 'block'
                  }}
                  allow="payment"
                />
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
